import { useCallback, useState } from 'react'

export function useHandlers() {
  const [propertyDetailsOpen, setPropertyDetailsOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined)

  const handleClick = useCallback(async (e: React.MouseEvent<HTMLElement>) => {
    if (e.currentTarget.parentElement) {
      setAnchorEl(e.currentTarget.parentElement)
    }

    setPropertyDetailsOpen(true)
  }, [])

  const onClose = useCallback(() => {
    setPropertyDetailsOpen(false)
  }, [])

  return {
    handleClick,
    onClose,
    propertyDetailsOpen,
    anchorEl,
  }
}
